import { useSeeHint } from "components/hint/Hint";
import { useGetState, useSetState } from "components/ReduxProvider";
import { useViewerQuery, useViewerXps } from "queries/viewerQuery";
import React from "react";
import { Trans } from "react-i18next";
import styled, { keyframes } from "styled-components/macro";
import { dispatchEvent, EVENT } from "tools/events";
import QuestReward from "./QuestReward";
import TutorialPointer from "../../../tutorial/TutorialPointer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { QuestMessage } from "./misc/QuestMessage";
import { Quest } from "./Quest";
import { QuestCloseButton } from "./misc/QuestCloseButton";
import { faMessages, faHeadphones } from "@duocards/pro-regular-svg-icons";
import { PRACTICE_BUTTON_ID } from "components/other/BottomNavigation";
export const LISTEN_VOCAB_QUEST = "listenVocabQuest";

const Wrap = styled.div``;

const SDiv = styled.div<{ crossed?: boolean }>`
  text-decoration: ${({ crossed }) => (crossed ? "line-through" : "none")};
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: center;
`;

const pulsingRotatedKF = keyframes`
  0%, 100% { transform: scale(1) rotate(95deg) translateY(-7px); }
  50% {  transform: scale(1.3) rotate(85deg) translateY(7px);}
`;

const STutorialPointer = styled(TutorialPointer)`
  position: absolute;
  animation: ${pulsingRotatedKF} 1.5s ease-in-out infinite;
  left: -15%;
`;

const SRow = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

const REWARD_XP = 5;
type Props = {};

export const useIsQuestListenVocab = () => {
  const { hintWasSeen } = useViewerQuery();
  const currentQuest = useGetState("currentQuest");
  const questListenVocabCompleted = useGetState("questListenVocab");
  const { xps } = useViewerXps();
  if (!currentQuest || !xps) return false;

  return (
    !hintWasSeen(LISTEN_VOCAB_QUEST) &&
    currentQuest?.name === "ListenVocabQuest" &&
    xps?.total >= currentQuest.startXps &&
    !questListenVocabCompleted
  );
};

const ListenVocabQuest: React.FC<Props> = () => {
  const { hintWasSeen } = useViewerQuery();
  const questListenVocab = useGetState("questListenVocab");
  const seeHint = useSeeHint();
  const { xps } = useViewerXps();
  const setLastQuestXps = useSetState("lastQuestXps");

  return (
    <Quest questName="ListenVocabQuest" requiredExps={1}>
      <QuestMessage visible={!hintWasSeen(LISTEN_VOCAB_QUEST)}>
        <QuestCloseButton
          onClick={() => {
            seeHint(LISTEN_VOCAB_QUEST);
          }}
        />
        <Wrap>
          <QuestReward
            rewardedXps={REWARD_XP}
            claim={questListenVocab}
            onDone={() => {
              seeHint(LISTEN_VOCAB_QUEST);
              setTimeout(() => dispatchEvent(EVENT.updateMain));
              setLastQuestXps((xps?.total || 0) + REWARD_XP);
            }}
          />
          <SDiv crossed={questListenVocab}>
            <Trans parent="div">Listen to your words while excercising / driving / ...</Trans>
            <SRow>
              <Trans>1. Go to the Practice section</Trans>
              <FontAwesomeIcon icon={faMessages} />
            </SRow>
            <SRow>
              <Trans>2. Tap "Listen"</Trans>
              <FontAwesomeIcon icon={faHeadphones} />
            </SRow>
          </SDiv>

          {!questListenVocab && (
            <STutorialPointer pulsing container={() => document.getElementById(PRACTICE_BUTTON_ID)} />
          )}
        </Wrap>
      </QuestMessage>
    </Quest>
  );
};

export default ListenVocabQuest;
